<template>
  <div class="investors">
    <nav class='sub-menu'>
      <div class='centered'>
        <span v-for="item in investorPages" @click="handleGetInvestorPage"
          v-bind:key="item.id" class='nav-elem'
        >
          <router-link :to="{ name: 'Investor', params: { id: item.id } }"
            active-class="is-active" :key="item.id"
            :class="!$route.params.id && item.id === investorPages[0].id ? 'is-active' : '' "
          >
            {{ item.title }}
          </router-link>
        </span>

        <span class="button-wrapper centered nav-elem" @click="addInvestorPage"
          v-if='investorPages && investorPages.length < 2'
        >
          <a class='button is-info'>+</a>Страница
        </span>
      </div>
    </nav>

    <Investor v-if='investorPage'/>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'

  import Investor from './investorComponents/Investor'

  export default {
    name: 'Investors',
    data () {
      return { }
    },

    computed: {
      ...mapState(['investorPage', 'investorPages'])
    },

    methods: {
      ...mapActions(['getInvestorPage', 'getInvestorPages', 'addInvestorPage']),

      handleGetInvestorPage () {
        const id = this.$route.params.id
        if (id !== 'new') {
          this.getInvestorPage(id)
        }
      }
    },

    created () {
      this.getInvestorPages(this.$route.params.id)
      if (this.$route.params.id && !this.investorPage) {
        this.getInvestorPage(this.$route.params.id)
      }
    },

    components: { Investor }
  }
</script>

<style>
.sub-menu {
  margin: 30px auto 30px;
}

.sub-menu ul li {
  padding: 0 10px;
  width: 100%;
}

.sub-menu ul li a {
  padding: 10px;
  display: inline-block;
}

.investors .page-header-wrapper {
  background: #eeeeee;
}

.caption {
  text-align: center;
  margin: 20px 0;
}

.centered {
  display: flex;
  align-items: center;
  justify-content: center;
}

.advantages .button-wrapper,
.calculator-option .switch {
  justify-content: center;
}

.is-active {
  border-bottom: 3px solid #7957d5;
  display: inline-block;
  padding-bottom: 0;
}

.switch-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.nav-elem {
  margin: 0 10px;
}
</style>



// WEBPACK FOOTER //
// Investors.vue?68c730f0